// The landing stat strip (brief §5.1 / prototype landingView): active workflows, the needs-a-decision
// total across all boards, and the next due sweep — every figure DERIVED from the definitions the
// projection lists (G-182), never a hand-kept number. Machine hooks ride data-stat wrappers so tests
// assert the derivation, not presentation copy (G-180).

import { Dot, StatCard, StatStrip } from '../../../primitives.tsx';
import type { WorkLandingDefinitionRow } from '../../projections.ts';
import { deriveLandingStats } from '../landing-model.ts';

export interface LandingStatsProps {
  readonly definitions: readonly WorkLandingDefinitionRow[];
}

/** The three landing stat cards, derived from the projection. */
export function LandingStats({ definitions }: LandingStatsProps): React.JSX.Element {
  const stats = deriveLandingStats(definitions);
  return (
    <StatStrip>
      <div data-stat="active-workflows">
        <StatCard
          label="Active workflows"
          value={stats.activeCount}
          note={stats.pausedCount > 0 ? `${stats.pausedCount} paused` : 'none paused'}
        />
      </div>
      <div data-stat="needs-decision">
        <StatCard
          label="Needs a decision"
          value={
            stats.needsDecision > 0 ? (
              <span className="inline-flex items-center gap-2">
                <Dot tone="attention" />
                {stats.needsDecision}
              </span>
            ) : (
              stats.needsDecision
            )
          }
          note="across all boards"
        />
      </div>
      <div data-stat="next-sweep">
        <StatCard
          label="Next sweep"
          value={<span className="text-xl">{stats.nextSweep?.at ?? '—'}</span>}
          note={
            stats.nextSweep !== null
              ? `${stats.nextSweep.cadenceLabel} · whole board`
              : 'none scheduled'
          }
        />
      </div>
    </StatStrip>
  );
}
